import { Component } from '@theme/component';
import { fetchConfig, debounce } from '@theme/utilities';
import {
  ThemeEvents,
  QuantitySelectorBulkUpdateEvent,
  CartUpdateEvent
} from '@theme/events';


class QuickOrderBulkComponent extends Component {
  
  #isFetching = false;
  #debouncedOnChange = debounce(this.#onQuantityChange, 300).bind(this);

  connectedCallback() {
    super.connectedCallback(); 

    this.addEventListener('quickadd:quantitychange', (event) => {
      const { variantId, quantity } = event.detail;
      // Handle the quantity change here
      this.#debouncedOnChange(event);
    });

  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  #onQuantityChange(event) {

    // get the quantity, variant id and row
    const { quantity, variantId: variantId, row } = event.detail;
    const quickOrderItemRow = event.target?.closest('quick-add-item') || row;

    if (this.#isFetching) return; // Prevent multiple fetches
    this.#isFetching = true;

    // set body
    const body = JSON.stringify({
      updates: {
        [variantId]: Number(quantity)
      }
    });

    // update the cart
    fetch(Theme.routes.cart_update_url,  fetchConfig('json', { body }))
      .then(res => res.json())
      .then(cart => {
        
        // update the pricing
        const productUrl = this.dataset.productUrl;
        const sectionId = 'product-card'; // Replace with your actual section ID if different
        
        // is this a single varient, or a list of variants
        const isSingleVariant = quickOrderItemRow.dataset.singleVariant ? true : false;
        const productCountElement = this.querySelector('.product_count');
        const variantPriceElement = quickOrderItemRow.querySelector('.variant_price')
        const variantSubtotalElement = quickOrderItemRow.querySelector('.variant_subtotal')
        const productSubtotalElement = this.querySelector('.product_subtotal');
        const qtyCover = quickOrderItemRow.querySelector('.quantity_cover');
        
        console.log(isSingleVariant);

        if(!isSingleVariant) {
          productCountElement.classList.add('opacity-0');
          variantSubtotalElement.classList.add('opacity-0');
          variantPriceElement.classList.add('opacity-0');
          productSubtotalElement.classList.add('opacity-0');
          qtyCover.classList.remove('hidden');
        }

        // no need to update the pricing on single variants
        if(!isSingleVariant) {

          fetch(`${productUrl}?section_id=${sectionId}`)
          .then(res => res.text())
          .then(html => {
            // Create a temporary DOM to parse the HTML
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;

            // Find the quick-add-item component with the same variant-id
            const variantId = quickOrderItemRow.dataset.variantId;
            const productId = quickOrderItemRow.dataset.productId;

            const newProductCountElement = tempDiv.querySelector('.product_count');
            const newVariantPriceElement = tempDiv.querySelector(`quick-add-item[data-variant-id="${variantId}"] .variant_price`);
            const newVariantSubtotalElement = tempDiv.querySelector(`quick-add-item[data-variant-id="${variantId}"] .variant_subtotal`);
            const newProductSubtotalElement = tempDiv.querySelector('.product_subtotal');
            const newQtyValue = tempDiv.querySelector(`quick-add-item[data-variant-id="${variantId}"] .quantity__input`).value;

            quickOrderItemRow.querySelector('.quantity__input').value = newQtyValue;

            qtyCover.classList.add('hidden');
            productCountElement.replaceWith(newProductCountElement);
            variantPriceElement.replaceWith(newVariantPriceElement);
            variantSubtotalElement.replaceWith(newVariantSubtotalElement);
            productSubtotalElement.replaceWith(newProductSubtotalElement);
            
            // Dispatch cart update event BEFORE replacing the element
             // Add preventCartDrawer: true to signal that cart drawer should not open
             // Dispatch on document to ensure it reaches the cart drawer listener
             document.dispatchEvent(
              new CartUpdateEvent(
                {},
                this.dataset.sourceId || null,
                {
                  source: 'quantity-selector',
                  variantIds: variantId,
                  itemCount: cart.item_count,
                  preventCartDrawer: true // Add this flag to prevent cart drawer
                }
              )
            );

          });
        } else {

          this.dispatchEvent(
            new CartUpdateEvent(
              {},
              this.dataset.sourceId || null,
              {
                source: 'quantity-selector',
                variantId: variantId,
                itemCount: cart.item_count,
              }
            )
          );

        }
          
      })
      .catch(error => {
        // this.dispatchEvent(
        //   new CartErrorEvent(
        //     this.dataset.sourceId || null,
        //     error.message || 'Cart update failed'
        //   )
        // );
        console.error(error);
      })
      .finally(() => {
        //console.log('no longer fetching')
        this.#isFetching = false;
      });

  }

  /**
   * Handles the line item removal.
   * @param {number} variantId - The line item index.
   */
  itemClear(variantId) {
    
    const row = this.querySelector(`quick-add-item[data-variant-id="${variantId}"]`);
    const event = {
      detail: {
        variantId,
        quantity: 0,
        row: row
      }
    };
    row.querySelector('.quantity__input').value = 0;
    this.#onQuantityChange(event);
  }

  /**
   * Handles the line item removal.
   * @param {Array} variantIds - The line item index.
   */
  clearAll(variantIds) {
    if (this.#isFetching) return; // Prevent multiple fetches
    this.#isFetching = true;

    // Convert variantIds string to array and create updates object
    const variantIdArray = variantIds.split(',').map(id => id.trim());
    // update the pricing
    const productUrl = this.dataset.productUrl;
    const sectionId = 'product-card'; // Replace with your actual section ID if different

    // Create body with all variant quantities set to 0
    const body = JSON.stringify({
      updates: variantIdArray.reduce((acc, variantId) => {
        acc[variantId] = 0;
        return acc;
      }, {})
    });

    // Update the cart with all quantities set to 0
    fetch(Theme.routes.cart_update_url, fetchConfig('json', { body }))
      .then(res => res.json())
      .then(cart => {
        
                 fetch(`${productUrl}?section_id=${sectionId}`)
           .then(res => res.text())
           .then(html => {
             // Create a temporary DOM to parse the HTML
             const tempDiv = document.createElement('div');
             tempDiv.innerHTML = html;

             const newQuickOrderBulk = tempDiv.querySelector('quick-order-bulk');
             //log(this)

             // Dispatch cart update event BEFORE replacing the element
             // Add preventCartDrawer: true to signal that cart drawer should not open
             // Dispatch on document to ensure it reaches the cart drawer listener
             document.dispatchEvent(
               new CartUpdateEvent(
                 {},
                 this.dataset.sourceId || null,
                 {
                   source: 'quick-order-bulk',
                   variantIds: variantIdArray,
                   itemCount: cart.item_count,
                   preventCartDrawer: true // Add this flag to prevent cart drawer
                 }
               )
             );

             // Replace the element after dispatching the event
             this.replaceWith(newQuickOrderBulk);
           });

      })
      .catch(error => {
        console.error('Error clearing all items:', error);
      })
      .finally(() => {
        this.#isFetching = false;
      });
  }

  
}

if (!customElements.get('quick-order-bulk')) {
  customElements.define('quick-order-bulk', QuickOrderBulkComponent);
}